import React, { useState } from 'react';
import ClientCard from './ClientCard';
import { clients } from '../utils/constants';
import { Box, Button, FormControl, Grid, Modal, TextField, Typography } from '@mui/material';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import ModalHeader from '../modals/ModalHeader';
import ModalFooter from '../modals/ModalFooter';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '40%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  fontFamily: 'Poppins',
  height: 'max-content',
  overflowY: 'scroll',
  p: 2,
};

const Clients = () => {
  const [openModal, setOpenModal] = useState(false);
  const [newClient, setNewClient] = useState({ name: '', phone: '' });
  const [request, setRequest] = useState(false);

  const handleModalOpen = () => setOpenModal(true);
  const handleModalClose = () => setOpenModal(false);

  // Handle form field changes for new client
  const handleFieldChange = (e) => {
    setNewClient({ ...newClient, [e.target.name]: e.target.value });
  };

  // Handle Add Client submission
  const handleAddClient = (event) => {
    event.preventDefault();
    // You can replace this logic with whatever you need to do after adding the client
    console.log(newClient);
    setRequest(false); // Reset request state (if showing loading spinner)
    handleModalClose(); // Close the modal
    setNewClient({ name: '', phone: '' }); // Reset form fields
  };

  return (
    <div style={styles.container}>
      {/* Header and Add Client Button */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#000' }}>
          Client Details
        </Typography>
        <Button
          variant="contained"
          color="primary"
          sx={{
            backgroundColor: '#2F3B57',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
          onClick={handleModalOpen}
        >
          <AddCircleOutlineOutlinedIcon sx={{ marginRight: 1 }} /> Add Client
        </Button>
      </Box>

      {/* Client Cards */}
      <div style={styles.cardContainer}>
        {clients.map((client) => (
          <ClientCard key={client.id} client={client} />
        ))}
      </div>

      {/* Modal for Adding New Client */}
      <Modal open={openModal} onClose={handleModalClose}>
        <Box sx={style} className="sm_modal">
          {/* Modal Header */}
          <ModalHeader title="Add New Client" handleClose={handleModalClose} />

          {/* Form for Adding Client */}
          <Box
            component="form"
            id="addClient"
            validate
            autoComplete="off"
            onSubmit={handleAddClient}
            sx={{ '& .MuiTextField-root': { m: 2 } }}
          >
            <Grid container sx={{ pt: 1, display: 'flex', justifyContent: 'center' }}>
              {/* Name Field */}
              <Grid item md={10} xs={12}>
                <FormControl sx={{ width: '100%' }}>
                  <TextField
                    autoComplete="off"
                    label="Name"
                    name="name"
                    size="small"
                    value={newClient.name}
                    required
                    onChange={handleFieldChange}
                    fullWidth
                  />
                </FormControl>
              </Grid>

              {/* Phone Field */}
              <Grid item md={10} xs={12}>
                <FormControl sx={{ width: '100%' }}>
                  <TextField
                    autoComplete="off"
                    label="Phone Number"
                    name="phone"
                    size="small"
                    value={newClient.phone}
                    required
                    onChange={handleFieldChange}
                    fullWidth
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          {/* Modal Footer */}
          <ModalFooter
            form="addClient"
            request={request}
            btn="Add Client"
            disable={!newClient.name || !newClient.phone}
          />
        </Box>
      </Modal>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: '#f4f6f9',
    minHeight: '100vh',
  },
  cardContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    justifyItems: 'center',
    padding: '0 20px',
  },
};

export default Clients;
